<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <!-- 速度監視 -->
  <SpeedAlert />

  <!-- 駅エリア外警告 -->
  <OutOfStationAlertModal />

  <!-- 共通モーダル -->

  <!-- アラートモーダル -->
  <AlertModal
    v-model:is-open="alert.isOpen"
    :message="alert.message"
    :message-type="alert.messageType"
    @close="alert.onClose"
  />
  <!-- 確認モーダル -->
  <ConfirmModal
    v-model:is-open="confirm.isOpen"
    :message="confirm.message"
    :is-warning="confirm.isWarning"
    :accept-button-text="confirm.acceptButtonText"
    :cancel-button-text="confirm.cancelButtonText"
    @accept="confirm.onAccept"
    @cancel="confirm.onCancel"
  />
  <!-- エラーモーダル -->
  <ErrorModal
    v-model:is-open="error.isOpen"
    :display-id="error.displayId"
    :error-code="error.errorCode"
    :message="error.message"
    @close="error.onClose"
  />

  <!-- ローディングオーバーレイ -->
  <v-overlay v-model="isLoading" persistent>
    <div v-if="isLoading" class="position-fixed h-screen w-screen">
      <div class="d-flex justify-center align-center h-100 w-100">
        <v-progress-circular
          :size="40"
          :width="4"
          color="primary"
          indeterminate
        />
      </div>
    </div>
  </v-overlay>
</template>

<script setup lang="ts">
import AlertModal from '~/components/modal/common/AlertModal.vue';
import ConfirmModal from '~/components/modal/common/ConfirmModal.vue';
import ErrorModal from '~/components/modal/common/ErrorModal.vue';
import SpeedAlert from '~/components/modal/speed/SpeedAlert.vue';
import OutOfStationAlertModal from './components/modal/common/OutOfStationAlertModal.vue';

const { alert, confirm, error } = storeToRefs(useCommonModalStore());
const { isLoading } = storeToRefs(useLoadingStore());
const { fetchAllMessages } = useMasterStore();
const { startWatchState: startSpeedMonitorWatch } = useSpeedMonitor();
const { startWatchState: startPositionValidationWatch } = usePositionValidation();
const { onLoggedInByOtherTabs } = useMultiTabLoginControlLogic();

onMounted(async () => {
  // あらかじめ画面で使用するメッセージを取得しておく
  await fetchAllMessages('0-00');
  // 速度監視ロジックを起動する
  startSpeedMonitorWatch();
  // 駅エリア検知ロジックを起動する
  startPositionValidationWatch();
  // 複数タブでのログイン制御ロジックを起動する
  onLoggedInByOtherTabs();
});
</script>
